import { ShieldXIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type AccessDeniedViewProps = {
	title?: string;
	subtitle?: string;
};
export function AccessDeniedView({ title, subtitle }: AccessDeniedViewProps) {
	const { t } = useTranslation();
	return (
		<div className="h-full flex items-center justify-center p-6">
			<div className="text-center">
				<ShieldXIcon className="size-16 text-zinc-300 mx-auto mb-3" />
				<p className="text-zinc-500 font-medium">{title || t('health.empty.accessDeniedTitle')}</p>
				<p className="text-sm text-zinc-400 mt-1">{subtitle || t('health.empty.accessDeniedSubtitle')}</p>
			</div>
		</div>
	);
}
